import type { FC } from 'react';

import { Eyebrow } from '../../ui/Eyebrow';
import { NavItem } from '../../ui/NavItem';

import type { TSidebarSectionProps } from './SidebarSection.props';

const SidebarSection: FC<TSidebarSectionProps> = ({ section, pathname, isCollapsed }) => (
  <div className="mb-3.5">
    {section.eyebrow && !isCollapsed ? (
      <Eyebrow className="mb-1.5 block px-2.5">{section.eyebrow}</Eyebrow>
    ) : null}
    <div className="flex flex-col gap-0.5">
      {section.rows.map(row => (
        <NavItem
          key={row.label}
          label={row.label}
          icon={row.icon}
          count={row.count}
          href={row.href}
          isActive={row.href === pathname}
          isCollapsed={isCollapsed}
        />
      ))}
    </div>
  </div>
);

export {
  SidebarSection,
};
